const twenty = [
  {
    name: 'add',
    type: '20',
    size: '20px'
  },
  {
    name: 'add-new',
    type: '20',
    size: '20px'
  },
  {
    name: 'address-proof',
    type: '20',
    size: '20px'
  },
  {
    name: 'apps',
    type: '20',
    size: '20px'
  },
  {
    name: 'arrow-left',
    type: '20',
    size: '20px'
  },
  {
    name: 'arrow-right',
    type: '20',
    size: '20px'
  },
  {
    name: 'back-to-top',
    type: '20',
    size: '20px'
  },
  {
    name: 'bank-online-payments',
    type: '20',
    size: '20px'
  },
  {
    name: 'bank-otc-merchant',
    type: '20',
    size: '20px'
  },
  {
    name: 'bank-payments',
    type: '20',
    size: '20px'
  },
  {
    name: 'bulk-sheet-payment',
    type: '20',
    size: '20px'
  },
  {
    name: 'bulk-sheet-request',
    type: '20',
    size: '20px'
  },
  {
    name: 'cart',
    type: '20',
    size: '20px'
  },
  {
    name: 'centralized-management',
    type: '20',
    size: '20px'
  },
  {
    name: 'checkmark',
    type: '20',
    size: '20px'
  },
  {
    name: 'cheque',
    type: '20',
    size: '20px'
  },
  {
    name: 'chevron-down',
    type: '20',
    size: '20px'
  },
  {
    name: 'chevron-left',
    type: '20',
    size: '20px'
  },
  {
    name: 'chevron-right',
    type: '20',
    size: '20px'
  },
  {
    name: 'chevron-up',
    type: '20',
    size: '20px'
  },
  {
    name: 'clear',
    type: '20',
    size: '20px'
  },
  {
    name: 'clear-fill',
    type: '20',
    size: '20px'
  },
  {
    name: 'close',
    type: '20',
    size: '20px'
  },
  {
    name: 'collapse',
    type: '20',
    size: '20px'
  },
  {
    name: 'confirmation',
    type: '20',
    size: '20px'
  },
  {
    name: 'current-position',
    type: '20',
    size: '20px'
  },
  {
    name: 'customer-support',
    type: '20',
    size: '20px'
  },
  {
    name: 'dashboard-nav',
    type: '20',
    size: '20px'
  },
  {
    name: 'delete',
    type: '20',
    size: '20px'
  },
  {
    name: 'devices',
    type: '20',
    size: '20px'
  },
  {
    name: 'direction-left',
    type: '20',
    size: '20px'
  },
  {
    name: 'direction-right',
    type: '20',
    size: '20px'
  },
  {
    name: 'diverse-optimized-internet-traffic',
    type: '20',
    size: '20px'
  },
  {
    name: 'dongle',
    type: '20',
    size: '20px'
  },
  {
    name: 'download',
    type: '20',
    size: '20px'
  },
  {
    name: 'duplicate',
    type: '20',
    size: '20px'
  },
  {
    name: 'edit',
    type: '20',
    size: '20px'
  },
  {
    name: 'exit',
    type: '20',
    size: '20px'
  },
  {
    name: 'expand',
    type: '20',
    size: '20px'
  },
  {
    name: 'extended-global-reach',
    type: '20',
    size: '20px'
  },
  {
    name: 'external-page',
    type: '20',
    size: '20px'
  },
  {
    name: 'faqs',
    type: '20',
    size: '20px'
  },
  {
    name: 'filters',
    type: '20',
    size: '20px'
  },
  {
    name: 'full-screen',
    type: '20',
    size: '20px'
  },
  {
    name: 'hosted-backbone',
    type: '20',
    size: '20px'
  },
  {
    name: 'hot-deals',
    type: '20',
    size: '20px'
  },
  {
    name: 'information',
    type: '20',
    size: '20px'
  },
  {
    name: 'interconnect',
    type: '20',
    size: '20px'
  },
  {
    name: 'landline',
    type: '20',
    size: '20px'
  },
  {
    name: 'livechat',
    type: '20',
    size: '20px'
  },
  {
    name: 'mail',
    type: '20',
    size: '20px'
  },
  {
    name: 'map',
    type: '20',
    size: '20px'
  },
  {
    name: 'multiple-billing-models',
    type: '20',
    size: '20px'
  },
  {
    name: 'news',
    type: '20',
    size: '20px'
  },
  {
    name: 'notifications',
    type: '20',
    size: '20px'
  },
  {
    name: 'one-stop-shop',
    type: '20',
    size: '20px'
  },
  {
    name: 'order-status',
    type: '20',
    size: '20px'
  },
  {
    name: 'page-next',
    type: '20',
    size: '20px'
  },
  {
    name: 'page-previous',
    type: '20',
    size: '20px'
  },
  {
    name: 'pagination-first',
    type: '20',
    size: '20px'
  },
  {
    name: 'pagination-last',
    type: '20',
    size: '20px'
  },
  {
    name: 'pay-as-you-go',
    type: '20',
    size: '20px'
  },
  {
    name: 'pay-phone',
    type: '20',
    size: '20px'
  },
  {
    name: 'payment',
    type: '20',
    size: '20px'
  },
  {
    name: 'payments-bank',
    type: '20',
    size: '20px'
  },
  {
    name: 'pop',
    type: '20',
    size: '20px'
  },
  {
    name: 'pop-cluster',
    type: '20',
    size: '20px'
  },
  {
    name: 'print',
    type: '20',
    size: '20px'
  },
  {
    name: 'proactive-alerts',
    type: '20',
    size: '20px'
  },
  {
    name: 'proactive-customized-customer-service',
    type: '20',
    size: '20px'
  },
  {
    name: 'rates',
    type: '20',
    size: '20px'
  },
  {
    name: 'recharges',
    type: '20',
    size: '20px'
  },
  {
    name: 'refresh',
    type: '20',
    size: '20px'
  },
  {
    name: 'reports',
    type: '20',
    size: '20px'
  },
  {
    name: 'satellite',
    type: '20',
    size: '20px'
  },
  {
    name: 'save',
    type: '20',
    size: '20px'
  },
  {
    name: 'search',
    type: '20',
    size: '20px'
  },
  {
    name: 'secure-reliable',
    type: '20',
    size: '20px'
  },
  {
    name: 'social-media',
    type: '20',
    size: '20px'
  },
  {
    name: 'star',
    type: '20',
    size: '20px'
  },
  {
    name: 'star-fill',
    type: '20',
    size: '20px'
  },
  {
    name: 'static-ips',
    type: '20',
    size: '20px'
  },
  {
    name: 'strong-india-network',
    type: '20',
    size: '20px'
  },
  {
    name: 'subscriber-advantage',
    type: '20',
    size: '20px'
  },
  {
    name: 'talk',
    type: '20',
    size: '20px'
  },
  {
    name: 'text',
    type: '20',
    size: '20px'
  },
  {
    name: 'time',
    type: '20',
    size: '20px'
  },
  {
    name: 'toll-free-call',
    type: '20',
    size: '20px'
  },
  {
    name: 'traffic',
    type: '20',
    size: '20px'
  },
  {
    name: 'tv',
    type: '20',
    size: '20px'
  },
  {
    name: 'upload',
    type: '20',
    size: '20px'
  },
  {
    name: 'user',
    type: '20',
    size: '20px'
  },
  {
    name: 'user-edited',
    type: '20',
    size: '20px'
  },
  {
    name: 'user-removed-access',
    type: '20',
    size: '20px'
  },
  {
    name: 'user-removed-invitation',
    type: '20',
    size: '20px'
  },
  {
    name: 'utilization',
    type: '20',
    size: '20px'
  },
  {
    name: 'view',
    type: '20',
    size: '20px'
  },
  {
    name: 'vip-numbers',
    type: '20',
    size: '20px'
  },
  {
    name: 'virtual-numbers',
    type: '20',
    size: '20px'
  },
  {
    name: 'warning',
    type: '20',
    size: '20px'
  },
  {
    name: 'warning-fill',
    type: '20',
    size: '20px'
  },
  {
    name: 'world',
    type: '20',
    size: '20px'
  }
];

export default twenty;



// WEBPACK FOOTER //
// ./src/containers/foundations/Icons/constants/twenty.js